import { useState, useEffect } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import CustomSelect from "../globalno-dodavanje/CustomSelect";
import CustomSelectSimple from "./CustomSelectSimple";
import CustomCalendarInput from "./CustomCalendarInput";
import axios from "axios";
import { useGlobalContext } from "../../../../Context/Context";

const vrsteAll = ["POJEDINACNA", "KOLEKTIVNA"];
const oceneAll = ["LAKA", "TESKA", "SMRTNA"];

const nowDate = new Date()
  .toLocaleDateString("sr-RS", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
  .replaceAll("/", ".")
  .slice(0, -1);

const emptyObrazac = {
  radnoMesto: { id: -1, name: "" },
  zaposlen: { id: -1, name: "" },
  datum: nowDate,
  sat: "08",
  minut: "00",
  vrsta: "",
  ocena: "",
};

function EvidencijeObrazac2Dodavanje({ setIsDodavanje, onRefresh }) {
  const [obrazac, setObrazac] = useState(emptyObrazac);
  const [radnaMesta, setRadnaMesta] = useState([]);
  const [zaposleni, setZaposleni] = useState([]);

  const { baseUrl, selectedMainEntity } = useGlobalContext();

  useEffect(() => {
    const fetchLookups = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/evidencija1/get_lookups.php`,
          { company_id: selectedMainEntity.company_id },
        );
        if (data.status === 200) {
          setRadnaMesta(data.radna_mesta);
          setZaposleni(data.zaposleni);
        }
      } catch (e) {
        console.error("Greška:", e);
      }
    };
    fetchLookups();
  }, []);

  const handleChange = (newValue, field) => {
    setObrazac((prev) => ({ ...prev, [field]: newValue }));
  };

  const formatDateForApi = (dateStr, sat, minut) => {
    if (!dateStr) return null;
    const parts = dateStr.split(".");
    if (parts.length < 3) return null;
    return `${parts[2]}-${parts[1]}-${parts[0]} ${sat}:${minut}:00`;
  };

  const handleSacuvaj = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija2/create.php`, {
        company_id: selectedMainEntity.company_id,
        workplace_id: obrazac.radnoMesto.workplace_id || obrazac.radnoMesto.id,
        employee_id: obrazac.zaposlen.employee_id || obrazac.zaposlen.id,
        datum_povrede: formatDateForApi(
          obrazac.datum,
          obrazac.sat,
          obrazac.minut,
        ),
        vrsta: obrazac.vrsta,
        ocena: obrazac.ocena,
      });
      if (data.status === 200) {
        onRefresh();
        setIsDodavanje(false);
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const handleOdustani = () => setIsDodavanje(false);

  const isDisabledSacuvaj =
    obrazac.zaposlen.id === -1 ||
    obrazac.radnoMesto.id === -1 ||
    !obrazac.ocena ||
    !obrazac.vrsta;

  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "space-between",
        }}
      >
        <div style={{ width: "15vw" }}>
          <CustomSelect
            label="РАДНО МЕСТО"
            allValues={radnaMesta}
            selectedValue={obrazac.radnoMesto}
            onSelectChange={(newValue) => handleChange(newValue, "radnoMesto")}
          />
        </div>

        <div style={{ width: "15vw" }}>
          <CustomSelect
            label="ИМЕ И ПРЕЗИМЕ"
            allValues={zaposleni}
            selectedValue={obrazac.zaposlen}
            onSelectChange={(newValue) => handleChange(newValue, "zaposlen")}
          />
        </div>

        <CustomCalendarInput
          label="ДАТУМ"
          value={obrazac.datum}
          onChange={(v) => handleChange(v, "datum")}
        />

        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px",
            }}
          >
            САТ
          </div>
          <input
            value={obrazac.sat}
            onChange={(e) => handleChange(e.target.value, "sat")}
            style={{
              fontSize: "16px",
              height: "40px",
              padding: "10px",
              width: "60px",
            }}
            maxLength={2}
          />
        </div>

        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px",
            }}
          >
            МИНУТ
          </div>
          <input
            value={obrazac.minut}
            onChange={(e) => handleChange(e.target.value, "minut")}
            style={{
              fontSize: "16px",
              height: "40px",
              padding: "10px",
              width: "60px",
            }}
            maxLength={2}
          />
        </div>

        <div style={{ width: "15vw" }}>
          <CustomSelectSimple
            label="ВРСТА ПОВРЕДЕ"
            allValues={vrsteAll}
            selectedValue={obrazac.vrsta}
            onSelectChange={(newValue) => handleChange(newValue, "vrsta")}
          />
        </div>

        <div style={{ width: "15vw" }}>
          <CustomSelectSimple
            label="ТЕЖИНА ПОВРЕДЕ"
            allValues={oceneAll}
            selectedValue={obrazac.ocena}
            onSelectChange={(newValue) => handleChange(newValue, "ocena")}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <div onClick={handleOdustani}>
          <Button activation={true} style={styles.button}>
            ОДУСТАНИ
          </Button>
        </div>
        <div
          onClick={isDisabledSacuvaj ? undefined : handleSacuvaj}
          style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}
        >
          <Button
            isDisabled={isDisabledSacuvaj}
            activation={true}
            style={styles.button}
          >
            САЧУВАЈ
          </Button>
        </div>
      </div>
    </div>
  );
}

export default EvidencijeObrazac2Dodavanje;
